// src/lib/floorWeek.js
// STATUS: active | UPDATED: 2026-09-24
// LOG:
//   2026-09-24  New. The queries behind floorScore.js.
//
// Five reads for the week, shaped into per person counts.
//
// NO ROLE CHECK ANYWHERE IN HERE, which is the same decision floorMetrics.js
// made and for the same reason. RLS already scopes every one of these tables to
// the caller's own floor, so this asks for everything it can see and lets the
// database decide what that is. A salesperson calling it gets their own rows
// and nothing else, with no second copy of the rule to keep in step.

import { supabase } from './supabase'
import { tally } from './floorScore'
import { WEEK_DAYS } from './floorScore'

const DAY = 24 * 60 * 60 * 1000

export function weekAgo(now = new Date()) {
  return new Date(now.getTime() - WEEK_DAYS * DAY).toISOString()
}

export async function loadFloorWeek(now = new Date()) {
  const since = weekAgo(now)
  const [signoffs, takes, checks, commitments, drills] = await Promise.all([
    // decided_at, not created_at: a sign off counts on the day the manager
    // approved it, not the day it was asked for.
    supabase.from('manager_signoffs').select('user_id, status, decided_at').gte('decided_at', since),
    supabase.from('peer_takes').select('author_id, status, created_at').gte('created_at', since),
    supabase.from('knowledge_check_attempts').select('user_id, passed, created_at').gte('created_at', since),
    // resolved_at for the same reason. A commitment written six weeks ago and
    // kept yesterday is this week's work.
    supabase.from('commitments').select('user_id, status, resolved_at').gte('resolved_at', since),
    supabase.from('activity_events').select('user_id, created_at').eq('kind', 'practice_drill').gte('created_at', since),
  ])

  const err = signoffs.error || takes.error || checks.error || commitments.error || drills.error
  return {
    counts: tally({
      signoffs: signoffs.data,
      takes: takes.data,
      checks: checks.data,
      commitments: commitments.data,
      drills: drills.data,
    }),
    error: err ? err.message || String(err) : null,
  }
}
